export default "__VITE_ASSET__dc1b4ea5__"